/**
 * Question World Module - QuestionsImage Component
 * Displays images and files attached to a question
 */

import React from 'react';
import { Row, Col, Space, Image } from 'antd';
import { bucket_url, bucket_url_old } from '../../helpers/constants';
import PdfPlaceholder from '../../assets/pdf_placeholder.png';

const QuestionsImage = ({ question }) => {
    return (
        <Row style={{ marginTop: 20, marginBottom: 20 }}>
            <Col xs={23} md={23} offset={1}>
                <Space>
                    {!!question &&
                        question?.image &&
                        question.image.map((item, index) => (
                            <Image
                                key={index}
                                placeholder
                                src={(item?.startsWith('user') ? bucket_url_old : bucket_url) + item}
                                width={'100%'}
                                style={{ objectFit: 'contain' }}
                            />
                        ))}
                    {!!question &&
                        question?.file &&
                        question.file.map((item, index) => (
                            <a
                                key={index}
                                href={(item?.startsWith('user') ? bucket_url_old : bucket_url) + item}
                                target='_blank'
                                rel='noreferrer'
                            >
                                <Image
                                    alt='PDF File'
                                    placeholder={<Image src={PdfPlaceholder} />}
                                    src={(item?.startsWith('user') ? bucket_url_old : bucket_url) + item}
                                    fallback={PdfPlaceholder}
                                    width={'100%'}
                                    style={{ objectFit: 'contain' }}
                                />
                            </a>
                        ))}
                </Space>
            </Col>
        </Row>
    );
};

export default React.memo(QuestionsImage);

